// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4b21e560a8185a70b60c","655":"3e6a2fb5b5c0200a0dc9"}[chunkId] + ".js";
};